// 规则提示枚举
export const filterRuleEnum = {
  term: { tip: '=', fieldKey: 'keyword' },
  term_not: { tip: '!=', fieldKey: 'keyword' },
  include: { tip: '包含', fieldKey: 'keyword' },
  exclude: { tip: '不包含', fieldKey: 'keyword' },
  exists_not: { tip: '为空', fieldKey: 'keyword' },
  exists: { tip: '不为空', fieldKey: 'keyword' },
  lt: { tip: '<', fieldKey: 'num' },
  lte: { tip: '<=', fieldKey: 'num' },
  gt: { tip: '>', fieldKey: 'num' },
  gte: { tip: '>=', fieldKey: 'num' },
  range: { tip: '区间', fieldKey: 'numArr' },
  lrange: { tip: '区间(左等)', fieldKey: 'numArr' },
  rrange: { tip: '区间(右等)', fieldKey: 'numArr' },
  erange: { tip: '区间(全等)', fieldKey: 'numArr' },
  eq_number: { tip: '等于', fieldKey: 'fieldCount' },
  gt_number: { tip: '大于', fieldKey: 'fieldCount' },
  gte_number: { tip: '大于等于', fieldKey: 'fieldCount' },
  lt_number: { tip: '小于', fieldKey: 'fieldCount' },
  lte_number: { tip: '小于等于', fieldKey: 'fieldCount' }
};

// 图表设置
export const chartDefaultConfig = {
  lineChart: null,
  lineChart2: null,
  barChart: null,
  barXChart: null,
  pieChart: null,
  pieChart2: null,
  numChart: null,
  tableChart: null,
  tableAnalysisChart: null
};

// echarts主题配置列表
export const chartThemeArr = [
  {
    name: '彩色',
    key: 'colors',
    colors: [
      '#0b8dff',
      '#03dbcd',
      '#ffd600',
      '#ff8a00',
      '#fc752d',
      '#7f49ff',
      '#6547ff',
      '#81e600',
      '#10cc63',
      '#fa4f9b',
      '#df20f8',
      '#f6fc50',
      '#ff2d51',
      '#48f3ff',
      '#cbfc56',
      '#8468fc'
    ]
  },
  {
    name: '单色',
    key: 'only',
    colors: ['#2483f4']
  },
  {
    name: '纯色',
    key: 'solid',
    colors: ['#2483f4', '#1991fb', '#1ea3ff', '#52bdff', '#98d2ff', '#9ddbff']
  },
  {
    name: '黑白',
    key: 'blackWhite',
    colors: ['#364053', '#515b6e', '#616c7c', '#727d8d', '#838f9e', '#9ca6b5', '#b4beca', '#d4dbe3', '#ebeff4']
  }
];

// 类型对应的aggType
export const aggMap = {
  text: 'term',
  num: 'interval',
  date: 'date'
};
